<template>

    <!-- Job Detail Page Heading (contains buttons to create, go back to prev and create a job) starts here -->
    <div class="job-detail-heading" v-bind:class="{'align-right': isBusinessJobListPage === true}">

      <button v-if="isApplicationPage" class="back-button app-btn" @click="$emit('backToApplications', 'Applications')">
        <img src="../../assets/images/back-arrow.png" alt="direction icon"/>
        <div>Back To Applications</div>
      </button>

      <button v-else-if="!isApplicationPage && !isBusinessJobListPage" class="back-button" @click="$emit('backToJobs', 'Jobs')">
        <img src="../../assets/images/back-arrow.png" alt="direction icon"/>
        <div>Back To Jobs</div>
      </button>

      <!-- Start of Edit and Create Button Div container -->
      <div class="job-buttons-container">
        <button v-if="isJobDetailPage && loggedInUserId === jobOwnerId" class="edit-job-btn" @click="$emit('editJob', jobId)">
          <div>Edit Job</div>
          <img src="../../assets/images/edit-blue.svg" alt="Edit icon"/>
        </button>

        <button v-if="loggedInUserType !== 'normal-user'" class="create-job-btn" @click="$emit('backToPostJob', 'Post Job')">
          <!-- <img class="job-create-icon" src="../../assets/images/profile-plus.svg" alt="Create job icon" /> -->
          <div>Create a Job</div>
        </button>

      </div>
      <!-- End of Edit and Create Button Div container -->

    </div>
    <!-- Job Detail Page Heading (contains buttons to create, go back to prev and create a job) ends here -->
</template>
<script>


export default {

  name: 'TopButtonsComponent',

  props: [
    'jobCreatorId',
    'isJobDetailPage',
    'isApplicationPage',
    'jobId',
    'isBusinessJobListPage'
  ],

  components: {
  },

  data() {
    return {
      // jobOwnerId: this.jobCreatorId,
      // loggedInUserId: '',
      loggedInUserType: this.$store.state.userData.userType,
    };
  },

  methods: {

  },

  computed : {
    loggedInUserId() {
      return this.$store.state.userData.id;
    },
    jobOwnerId() {
      return this.jobCreatorId;
    }
  },

  mounted() {

  },

  updated() {
    this.loggedInUserType = this.$store.state.userData.userType;
  }
};
</script>

<style scoped>
  .job-detail-heading {
    width:100%;
    display:flex;
    align-items:center;
    justify-content:space-between;
    margin-bottom: 41px;
  }

  .job-detail-heading.align-right {
    justify-content: flex-end;
  }

  .job-detail-heading button {
    display:flex;
    width:188px;
    height:54px;
    align-items:center;
    justify-content:center;
  }

  .app-btn {
    max-width: 250px;
    width: unset !important;
  }

  .job-detail-heading img {
    width:23px;
    margin-right:12px
  }

  .back-button {
    border:none;
    font-size:1.1rem;
    font-weight:700;
    line-height:1.524rem;
  }

  .back-button img {
    margin-right:10px;
  }

  .job-buttons-container {
    display:flex;
    justify-content:center;
  }

  .create-job-btn {
    font-size:1.125rem;
    font-weight:600;
    background:var(--colorPrimary);
    border:none;
    color:var(--white);
    border-radius:5px;
    margin-left:30px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));
  }

  .edit-job-btn{
    font-size:1.25rem;
    font-weight:600;
    background:white;
    border:var(--colorPrimary) solid 1px;
    color: var(--colorPrimary);
    border-radius:5px;
  }

  .create-job-btn img{
    width:30px;
  }

  .edit-job-btn img{
    width:30px;
    padding-right:14px;
    margin-left:14px;
  }

  @media only screen and (max-width:1178px) {
    .job-detail-heading button {
      display:flex;
      width:180px;
      height:50px;
      align-items:center;
      justify-content:center;
    }
    .back-button{
        border:none;
        font-size:20px;
        font-weight:700;
        line-height:24.38px;
      }

      .back-button img {
        margin-right:10px;
      }

      .job-buttons-container{
        display:flex;
        justify-content:center;
      }

      .create-job-btn {
        font-size:1.11rem;
        font-weight:600;
        margin-left:30px;
      }

      .edit-job-btn{
        font-size:1.125rem;
        font-weight:600;
        background:white;
        border-radius:5px;
      }
  }

  @media only screen and (max-width:1078px) {
.back-button{
        border:none;
        font-size:16px;
        font-weight:700;
        line-height:24.38px;
      }

      .back-button img {
        margin-right:10px;
      }

      .job-buttons-container{
        display:flex;
        justify-content:center;
      }

      .create-job-btn {
        font-size:1rem;
        font-weight:600;
        background:var(--colorPrimary);
        border:none;
        color:var(--white);
        border-radius:5px;
        margin-left:30px;
      }

      .edit-job-btn{
        font-size:1.11rem;
        font-weight:600;
        background:white;
        border:#025fa0 solid 1px;
      }
  }

  @media only screen and (max-width:990px) {

  }

  @media only screen and (max-width: 767px) {
      .job-buttons-container{
        flex-direction:column;
      }

      .create-job-btn {
        margin-left:0;
        margin-top:30px;
      }
  }

@media only screen and (max-width: 565px) {
  .job-detail-heading.align-right {
    justify-content: center;
  }
}

@media only screen and (max-width: 420px) {

}

</style>
